import { useEffect, useRef } from "react";
import { uuidv7 } from "uuidv7";

import layerManager from "src/utils/layerManager";

export default function useLayerEscapeClose(
  onClose: () => void,
  isVisible = true,
) {
  const latestOnClose = useRef(onClose);

  useEffect(() => {
    latestOnClose.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (isVisible) {
      const id = uuidv7();
      layerManager.add(id, () => latestOnClose.current());
      return () => {
        layerManager.remove(id);
      };
    }
  }, [isVisible]);

  return null;
}
